module.exports = __webpack_public_path__ + "static/horizontal-category-menu-d9b1b9e36f106de3a4ad73c63e131830.png";